import { useEffect, useState } from "react";
import { FeedItem } from "../components/ActivityFeed/FeedItem";
import { Activity } from "@mythic/coms/types";
import { useWebSocket } from "@mythic/coms/ui";
import TitleBar from "../components/TitleBar/TitleBar";

import "./ActivityFeed.css";
import { Message } from "@mythic/coms/types";

export function ActivityFeed() {
    const { subscribe, sendJson } = useWebSocket();

    const [activities, setActivities] = useState<Activity[]>([
        {
            title: "Test 1",
            text: "Text for Test 1",
            time: 0,
            type: "shop",
            user: "Toby",
            userName: "toby",
            userId: "32",
        },
        {
            title: "Test 2",
            text: "Text for Test 2",
            time: 0,
            type: "sound",
            user: "Toby",
            userName: "toby",
            userId: "32",
        },
        {
            title: "Test 3",
            text: "Text for Test 3",
            time: 0,
            type: "throwable",
            user: "Toby",
            userName: "toby",
            userId: "32",
        },
    ]);

    useEffect(() => {
        const unsub = subscribe(
            (msg: Message) => {
                if (msg.target !== "activityfeed") return;

                if (msg.action === "new")
                    setActivities((prev) => [...msg.data, ...prev]);
                else if (msg.action === "broadcast") setActivities(msg.data);
            },
            ["activityfeed"],
        );

        return () => {
            unsub();
        };
    }, []);

    return (
        <>
            <TitleBar title="Activity Feed" />
            <ul className="activity-feed-list">
                {activities.map((a) => {
                    return (
                        <li key={`${a.title}|${a.time}`}>
                            <FeedItem {...a} />
                        </li>
                    );
                })}
            </ul>
        </>
    );
}
